// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-control-zoom.leaflet-bar.leaflet-control {
  height: 73px;
}

.leaflet-touch .leaflet-bar a {
  height: 35px;
}

.leaflet-popup-content {
  margin: 0;
}

.leaflet-popup-content .dataPopupMap-item-title {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
}

.leaflet-popup-content .dataPopupMap-item-content {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 15px;
  margin: 0;
}

.leaflet-popup-content .dataPopupMap-title {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 600;
  text-align: center;
  font-size: 17px;
  margin: 0px 0px 5px 0px;
  padding: 8px 0px 8px 0px;
  background-color: rgba(229, 175, 121, 0.9215686275);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.leaflet-popup-content .dataPopupMap-boxItem {
  margin-left: 7px;
}

.leaflet-popup-content-wrapper {
  min-width: 550px;
  margin-top: 130px;
  background-color: rgba(253, 206, 156, 0.8196078431);
}

.capPhep-banDo-searchList-contaier:hover {
  background-color: #a4e6ff;
}

.banDo-chuThich-container {
  padding: 2px 10px 0px 6px;
}

.banDo-chuThich-title {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 15px;
  font-weight: 600;
}

.banDo-chuThich-item-tr {
  display: flex;
}

.banDo-chuThich-item-td-img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
}

.banDo-chuThich-item-td-content {
  display: flex;
  align-items: center;
  padding-left: 5px;
}

.banDo-chuThich-item-td-content-span {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
}

.banDo-searchList-itemClose {
  cursor: pointer;
  border-radius: 3px;
}

.banDo-searchList-itemClose:hover {
  background-color: #bae6fd;
}

.controllerCheckCoordinates {
  position: absolute;
  left: 10px;
  background-color: rgba(255, 255, 255, 0.8117647059);
  padding: 10px;
  z-index: 1000;
  top: 85px;
}

.custom-button {
  position: absolute;
  top: 300px;
  left: 10px;
  padding: 5px 10px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000;
  pointer-events: auto;
}

.leaflet-container a.leaflet-popup-close-button {
  top: 128px !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/BanDo/style.scss"],"names":[],"mappings":"AAiBA;EACE,YAAA;AAhBF;;AAmBA;EACE,YAAA;AAhBF;;AAkBA;EACE,SAAA;AAfF;;AAkBA;EACE,uDAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAfF;;AAiBA;EACE,uDAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAdF;;AAiBA;EACE,uDAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,mDAAA;EACA,4BAAA;EACA,6BAAA;AAdF;;AAsBA;EACE,gBAAA;AAnBF;;AAqBA;EACE,gBAAA;EACA,iBAAA;EACA,mDAAA;AAlBF;;AAoBA;EACE,yBAAA;AAjBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,uDAAA;EACA,eAAA;EACA,gBAAA;AAhBF;;AAkBA;EACE,aAAA;AAfF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAdF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAbF;;AAeA;EACE,uDAAA;EACA,eAAA;AAZF;;AAcA;EACE,eAAA;EACA,kBAAA;AAXF;;AAaA;EACE,yBAAA;AAVF;;AAYA;EACE,kBAAA;EACA,UAAA;EAEA,mDAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AAVF;;AAYA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;AATF;;AAWA;EACE,qBAAA;AARF","sourcesContent":["// .bando{\r\n//     height: 100%;\r\n//     position: relative;\r\n//     &-body{\r\n//         position: absolute;\r\n//         top: -15px;\r\n//         left: -20px;\r\n//         height: calc(100vh - 50px);\r\n//         width: calc(100vw - 353px);\r\n//     }\r\n// }\r\n\r\n// .leaflet-control-zoom {\r\n//     width: 40px;\r\n//     height: 40px;\r\n// }\r\n\r\n.leaflet-control-zoom.leaflet-bar.leaflet-control {\r\n  height: 73px;\r\n}\r\n\r\n.leaflet-touch .leaflet-bar a {\r\n  height: 35px;\r\n}\r\n.leaflet-popup-content {\r\n  margin: 0;\r\n}\r\n\r\n.leaflet-popup-content .dataPopupMap-item-title {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  margin: 0;\r\n}\r\n.leaflet-popup-content .dataPopupMap-item-content {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  margin: 0;\r\n}\r\n\r\n.leaflet-popup-content .dataPopupMap-title {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  font-size: 17px;\r\n  margin: 0px 0px 5px 0px;\r\n  padding: 8px 0px 8px 0px;\r\n  background-color: #e5af79eb;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n}\r\n\r\n// .leaflet-popup-content .dataPopupMap-titleItem {\r\n//     margin: 7px 0px 5px 0px;\r\n//     font-weight: 600;\r\n// }\r\n\r\n.leaflet-popup-content .dataPopupMap-boxItem {\r\n  margin-left: 7px;\r\n}\r\n.leaflet-popup-content-wrapper {\r\n  min-width: 550px;\r\n  margin-top: 130px;\r\n  background-color: #fdce9cd1;\r\n}\r\n.capPhep-banDo-searchList-contaier:hover {\r\n  background-color: #a4e6ff;\r\n}\r\n.banDo-chuThich-container {\r\n  padding: 2px 10px 0px 6px;\r\n}\r\n\r\n.banDo-chuThich-title {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n.banDo-chuThich-item-tr {\r\n  display: flex;\r\n}\r\n.banDo-chuThich-item-td-img {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 35px;\r\n}\r\n.banDo-chuThich-item-td-content {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 5px;\r\n}\r\n.banDo-chuThich-item-td-content-span {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-size: 14px;\r\n}\r\n.banDo-searchList-itemClose {\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n}\r\n.banDo-searchList-itemClose:hover {\r\n  background-color: #bae6fd;\r\n}\r\n.controllerCheckCoordinates {\r\n  position: absolute;\r\n  left: 10px;\r\n  // top: 25px;\r\n  background-color: #ffffffcf;\r\n  padding: 10px;\r\n  z-index: 1000;\r\n  top: 85px;\r\n}\r\n.custom-button {\r\n  position: absolute;\r\n  top: 300px;\r\n  left: 10px;\r\n  padding: 5px 10px;\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  z-index: 1000;\r\n  pointer-events: auto;\r\n}\r\n.leaflet-container a.leaflet-popup-close-button {\r\n  top: 128px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
